import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const Send = ({ style, children, ...props }: SvgIconProps) => (
  <SvgIcon {...props} style={style}>
    {children}
    <path d="M0 0h24v24H0z" fill="none"/><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
  </SvgIcon>
);

export default Send;
